import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
const ActionNotification: React.FC = () => {
  const [count, setCount] = useState(15);

  useEffect(() => {
    if (count <= 0) {
      window.location.reload();
      return;
    }
    const timer = setInterval(() => {
      setCount((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [count]);

  const handleTryNow = () => {
    window.location.reload();
  };

  return (
    <Stack mt={-0.3} spacing={0} direction="row">
      <Typography fontSize={13}>Connecting in {count}s...</Typography>
      <Button
        variant="text"
        onClick={handleTryNow}
        style={{
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        Try Now
      </Button>
    </Stack>
  );
};

export default ActionNotification;
